import React from "react";
import ReactDOM from "react-dom";
import Router from "./config/router";
import "./config/i18n";

import "bootstrap/dist/css/bootstrap.css";
import "./assets/css/global.css";
import './styles/tokens.scss'
import './styles/colors.scss'
import '@fontsource/montserrat/400.css'
import '@fontsource/montserrat/500.css'
import '@fontsource/montserrat/600.css'
import '@fontsource/montserrat/800.css'
import './styles/typography.scss'

require('dotenv').config({ path: '../.env' })

ReactDOM.render(<Router />, document.getElementById("root"));
